import type { LinkProps } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useHead } from '@unhead/react';
import { Grid, Spin } from 'antd';
import { ErrorComponent } from '@/features/erro/components/ErrorComponent';
import { LayoutBreadcrumbs } from '@/features/layout/components/LayoutBreadcrumbs';
import { PageBody } from './PageBody';
import { PageFooter } from './PageFooter';
import { PageHeader } from './PageHeader';

export function Page({
    children,
    loading = false,
    error,
    ghost = false,
    title,
    path,
    voltar,
}: {
    children: ReactNode;
    loading?: boolean;
    error?: Error | null;
    ghost?: boolean;
    title: string;
    path: string[] | false;
    voltar?: LinkProps;
}) {
    useHead({ title });

    const breakpoint = Grid.useBreakpoint();

    return (
        <div className={`${breakpoint.md ? 'px-4' : 'px-2'}`}>
            {path ? <LayoutBreadcrumbs path={path} voltar={voltar} /> : null}

            <Spin spinning={loading}>
                <div
                    className={
                        ghost
                            ? ''
                            : 'mb-[68px] flex min-h-[50vh] flex-col rounded-md bg-white shadow-md'
                    }
                >
                    {error ? (
                        <div className='p-2'>
                            <ErrorComponent error={error} />
                        </div>
                    ) : (
                        children
                    )}
                </div>
            </Spin>
        </div>
    );
}

Page.Header = PageHeader;
Page.Body = PageBody;
Page.Footer = PageFooter;
